import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import { ReportPage } from "../report/report";
import { ReportService } from "../../services/report.service";
import { WorkorderService } from "../../services/workorder.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-workorders',
  templateUrl: 'workorders.html',
})
export class WorkordersPage {

  busy = false;
  updatePerformed = false;
  workorders = [];
  workorders_planned = [];
  workorders_processing = [];
  workorders_done = [];
  selectedWorkorders = 0;
  selectedProcessingWorkorders = [];
  hasRookgasmetingSubscription = false;

  tab = 'planned';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: ApiService,
    public reportService: ReportService,
    public workorderService: WorkorderService,
    public translate: TranslateService,
    public alertCtrl: AlertController
  ) {
  }

  public goToNewWorkorder(workorder_type){
    this.reportService.setData({
      _allow_parent_company_id_change: true,
      workorder_type: workorder_type,
      workorder_nr: '',
      reference_nr: ''
    });
    this.navCtrl.push(ReportPage);
  }

  public chooseNewWorkorderType(){
    let buttons = [];
    buttons.push({
      text: this.translate.instant('1e inbedrijfstelling'),
      handler: () => {
        this.goToNewWorkorder('1');
      }
    });
    buttons.push({
      text: this.translate.instant('Onderhoud'),
      handler: () => {
        this.goToNewWorkorder('2');
      }
    });
    buttons.push({
      text: this.translate.instant('Storing'),
      handler: () => {
        this.goToNewWorkorder('3');
      }
    });
    buttons.push({
      text: this.translate.instant('Buitenbedrijfstelling'),
      handler: () => {
        this.goToNewWorkorder('7');
      }
    });
    buttons.push({
      text: this.translate.instant('Meer...'),
      handler: () => {
        this.chooseNewWorkorderType2();
      }
    });
    this.alertCtrl.create({
      title: this.translate.instant('Type werkorder'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public chooseNewWorkorderType2(){
    let buttons = [];
    buttons.push({
      text: this.translate.instant('Toestel verwijderen'),
      handler: () => {
        this.goToNewWorkorder('4');
      }
    });
    buttons.push({
      text: this.translate.instant('Garantiekaart invullen'),
      handler: () => {
        this.goToNewWorkorder('6');
      }
    });
    this.alertCtrl.create({
      title: this.translate.instant('Type werkorder'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public selectWorkorder(workorder){
    if(workorder.require_user_switch){
      // Workorder company switch
      this.alertCtrl.create({
        title: this.translate.instant('Ander bedrijf'),
        message: this.translate.instant('Deze werkorder is in opdracht van') + ' ' + workorder.company_title + '. ' + this.translate.instant('Wilt u inloggen bij dit bedrijf om deze werkorder uit te voeren?'),
        buttons: [
          {
            text: this.translate.instant('Nee'),
            role: 'cancel'
          },
          {
            text: this.translate.instant('Ja'),
            handler: () => {
              this.apiService.loginByCompanyUserId(workorder.company_user_id).then(() => {
                let tabs = this.navCtrl.parent;
                tabs.select(0);
              });
            }
          }
        ]
      }).present();
    } else {
      // Open workorder
      this.reportService.setData(workorder);
      this.navCtrl.push(ReportPage);
    }
  }

  public selectDoneWorkorder(workorder){
    this.alertCtrl.create({
      title: this.translate.instant('Voltooide werkorder'),
      message: this.translate.instant('Weet u zeker dat u deze voltooide werkorder wilt openen?') + ' <br>' + this.translate.instant('De status van deze werkorder verandert dan weer in \'In behandeling\' totdat u de werkorder weer opnieuw voltooid.'),
      buttons: [
        {
          text: this.translate.instant('Nee'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('Ja'),
          handler: () => {
            this.selectWorkorder(workorder);
          }
        }
      ]
    }).present();
  }

  public deleteWorkorder(workorder, api_delete){
    this.alertCtrl.create({
      title: this.translate.instant('Werkorder verwijderen?'),
      message: this.translate.instant('Weet je zeker dat je deze werkorder wilt verwijderen?'),
      buttons: [
        {
          text: this.translate.instant('Nee'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('Ja'),
          handler: () => {
            this.busy = true;
            this.reportService.setData({});
            this.workorderService.deleteWorkorder(workorder._id).then(() => {
              if(workorder.workorder_id && api_delete){
                this.apiService.deleteWorkorder(workorder.workorder_id).then(() => {
                  this.updateWorkorders();
                }).catch(() => {
                  this.updateWorkorders();
                })
              } else {
                this.updateWorkorders();
              }
            }).catch(() => {
              this.updateWorkorders();
            });
          }
        }
      ]
    }).present();
  }

  public deleteSelectedProcessingWorkorders() {
    this.alertCtrl.create({
      title: this.translate.instant('Werkorders verwijderen?'),
      message: this.translate.instant('Weet je zeker dat je de geselecteerde werkorders wilt verwijderen?'),
      buttons: [
        {
          text: this.translate.instant('Nee'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('Ja'),
          handler: () => {
            this.busy = true;
            this.reportService.setData({});
            this.workorderService.deleteWorkorders(this.selectedProcessingWorkorders).then(() => {
              this.updateWorkorders();
            }).catch(() => {
              this.updateWorkorders();
            });
          }
        }
      ]
    }).present();
  }

  private update(){
    this.hasRookgasmetingSubscription = this.apiService.hasActiveSubscription('ROOKGASMETING');
    this.busy = true;
    let data = this.reportService.getData();
    if(data && data._status == 'processing') this.tab = 'processing';
    if(data && data._status == 'done') this.tab = 'done';
    this.reportService.save().then(() => {
      this.updateWorkorders();
    }).catch(() => {
      this.updateWorkorders();
    })
  }

  private updateWorkorders(){
    // Get workorders from API
    this.apiService.getWorkorders().then((data) => {
      this.updatePerformed = true;
      this.workorderService.setWorkorders(data, true).then(() => {
        this.getWorkorders();
      }).catch((err) => {
        this.getWorkorders();
      });
    }).catch((err) => {
      this.updatePerformed = false;
      this.getWorkorders();
    })
  }

  private sortByTimePlanned(a, b){
    let a_time_planned = a.time_planned ? parseInt(a.time_planned) : 0;
    let b_time_planned = b.time_planned ? parseInt(b.time_planned) : 0;
    if (a_time_planned > b_time_planned) return 1;
    if (b_time_planned > a_time_planned) return -1;
    return 0;
  }

  private getWorkorders(){
    this.workorderService.getWorkorders().then((workorders) => {
      // @ts-ignore
      this.workorders = workorders;
      // Sort workorders
      this.workorders = this.workorders.sort(this.sortByTimePlanned);
      // Split workorders
      this.workorders_planned = [];
      this.workorders_processing = [];
      this.workorders_done = [];
      this.selectedProcessingWorkorders = [];
      for(let i = 0; i < this.workorders.length; i++){
        if(this.workorders[i]._status === 'processing') {
          this.workorders_processing.push(this.workorders[i]);
        } else if(this.workorders[i]._status === 'done'){
          this.workorders[i]._selected = false;
          this.workorders_done.push(this.workorders[i]);
        } else {
          this.workorders_planned.push(this.workorders[i]);
        }
      }
      // Set selectedWorkorders
      this.selectedWorkorders = 0;
      // Set workorders_planned._group
      let now = new Date();
      let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let today_timestamp = Math.floor(today.getTime() / 1000);
      let tomorrow_timestamp = today_timestamp + 86400;
      let day_of_week = (today.getDay()-1);
      if(day_of_week < 0) day_of_week += 7;
      let next_week_timestamp = Math.floor(today.getTime()/1000) + (86400 * (7 - day_of_week));
      let after_next_week_timestamp = next_week_timestamp + (86400 * 7);
      let group = '';
      let prev_group;
      for(let i = 0; i < this.workorders_planned.length; i++){
        prev_group = group;
        group = '';
        let workorder = this.workorders_planned[i];
        if(workorder.time_planned){
          if(parseInt(workorder.time_planned) >= today_timestamp){
            group = 'Vandaag';
          }
          if(parseInt(workorder.time_planned) >= tomorrow_timestamp){
            group = 'Deze week';
          }
          if(parseInt(workorder.time_planned) >= next_week_timestamp){
            group = 'Volgende week';
          }
          if(parseInt(workorder.time_planned) >= after_next_week_timestamp){
            group = 'Na volgende week';
          }
        }
        this.workorders_planned[i]._group = group;
        this.workorders_planned[i]._group_same_as_prev = (group == prev_group);
      }
      // Done
      this.busy = false;
    }).catch((err) => {
      this.busy = false;
      console.error(err);
    });
  }

  public toggleSelected(workorder){
    if(workorder._selected){
      this.selectedWorkorders--;
    } else {
      this.selectedWorkorders++;
    }
    workorder._selected = !workorder._selected;
  }

  public toggleProcessingSelected(workorder){
    if(workorder._processing_selected){
      const index = this.selectedProcessingWorkorders.indexOf(workorder);
      if (index !== -1) {
        this.selectedProcessingWorkorders.splice(index, 1);
      }
    } else {
      this.selectedProcessingWorkorders.push(workorder);
    }
    workorder._processing_selected = !workorder._processing_selected;
  }

  public sendWorkorders(){
    if(this.workorders_done.length === 0){
      return;
    }
    this.reportService.setData({});
    this.busy = true;
    this.workorderService.sendSelectedWorkorders(this.workorders_done).then(() => {
      this.busy = false;
      this.update();
    }).catch((error_code) => {
      this.busy = false;
      let msg = this.translate.instant('De gegevens konden niet verstuurd worden. Controleer uw internetverbinding en probeer het opnieuw.') + '(code: ' + Math.abs(error_code) + ')';
      if(error_code === -99){
        msg = this.translate.instant('Het is niet mogelijk om werkorders te versturen in de demo omgeving.');
      }
      this.alertCtrl.create({
        title: this.translate.instant('Fout'),
        message: msg,
        cssClass: 'alert-error',
        buttons: ['OK']
      }).present();
    });
  }

  public ionViewDidEnter() {
    console.log('ionViewDidLoad WorkordersPage');
    this.reportService.setActive(false);
    this.update();
  }

}



// WEBPACK FOOTER //
// ./src/pages/workorders/workorders.ts